import { User } from '@/Components/Pages/Accounts/types'

import { transformUserKeysForDatabase } from '@/Components/Pages/Admin/Users/util'
import { headers } from '@/util/requests'

export const editAccount = async ({
  userId,
  updatedUser,
  csrfToken
}: {
  userId: User['id']
  updatedUser: Partial<User>
  csrfToken: string
}) => {
  const response = await fetch(`/admin/users/${userId}`, {
    method: 'PATCH',
    headers: headers(csrfToken),
    body: JSON.stringify({
      user: transformUserKeysForDatabase(updatedUser)
    })
  })
  return response.json()
}

export const activateAccount = async ({
  user,
  token,
  csrfToken
}: {
  token: string
  user: {
    first_name: string
    last_name: string
    email: string
    password: string
    password_confirmation: string
  }
  csrfToken: string
}) => {
  const response = await fetch(`/activate_accounts/${token}`, {
    method: 'PATCH',
    headers: headers(csrfToken),
    body: JSON.stringify({
      user
    })
  })
  return response.json()
}
